import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cacheStorage: Map<string, Observable<any>> = new Map();

  constructor() {}

  cache<T>(url: string, httpRequestObservable: Observable<T>): Observable<T> {
    try {
      if (!this.cacheStorage.has(url)) {
        this.cacheStorage.set(url, httpRequestObservable.pipe(shareReplay(1)));
      }

      return this.cacheStorage.get(url);
    } catch (error) {
      return of(null);
    }
  }

  clearAllCache(): void {
    this.cacheStorage.clear();
  }

  clearByKey(key: string): void {
    this.cacheStorage.delete(key);
  }
}
